<template>
	<el-container>
		<Header ref="header"></Header>
		<div class="demand-issued-info">
			<p class="wrapper-title">需求信息</p>
			<el-form :model="demandInfo" ref="demandForm" label-position="left" label-width="80px" :hide-required-asterisk="true">
				<el-form-item label="分类" class="required" prop="root" :rules="{ required: true, message: '分类不能为空' }">
					<el-select style="width: 100%" v-model="demandInfo.root" placeholder="请选择">
						<el-option v-for="(item, index) in $product[0]" :key="index" :label="item" :value="String(index+1)"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="标题" class="required" prop="name" :rules="{ required: true, message: '标题不能为空' }">
					<el-input type="text" v-model="demandInfo.name" placeholder="请填写标题" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="有效期限" class="required" prop="name" :rules="{ required: true, message: '有效期不能为空' }">
					<el-input v-model.number="demandInfo.expires" placeholder="填写有效期（如：90天、长期、半年等）"></el-input>
				</el-form-item>
				<el-form-item label="预算费用" class="required" prop="name">
					<el-input type="text" v-model="demandInfo.price" placeholder="填写预算费用（默认面议）" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<RichTextEditor v-model="demandInfo.content"/>
			<button class="save" @click="save">保存</button>
			<button class="save" style="background-color: red;" v-if="$route.query.id!=undefined" @click="remove">删除</button>
			<button class="save" style="background-color: #f3f3f3;color: #333;" v-if="$route.query.id!=undefined" @click="view">预览</button>
		</div>
	</el-container>
</template>

<script>
import Header from '../../components/Header.vue'
import RichTextEditor from '@/components/RichTextEditor.vue'
import {Api} from "../../utils/axios.js"
export default {
	components: { RichTextEditor,Header },
	data: () => ({
		demandInfo: {
			root:'',
			name:'',
			price:'',
			expires:'',
			content:''
		},
		id:'',
		userInfo: {},
		needRefresh:false
	}),
	mounted() {
		this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"))
		window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
		this.id = this.$route.query.id
		if(this.id!=undefined&&this.id!=null&&this.id!=''){
			Api('need/detail',{id:this.$route.query.id,manage:true}).then((res) => {
				if(res.code==200){
					this.demandInfo = res.result
				}else{
					this.$message.error(res.msg)
				}
			})
		}
	},
	methods: {
		beforeunloadHandler (e) {
			if(this.needRefresh){
				window.parent.opener.location.reload()
			}
		},
		save() {
			this.$refs['demandForm'].validate(async valid => {
				if (valid) {
					var params = this.demandInfo
					params.id = this.$route.query.id
					params.contact = sessionStorage.getItem("uid")
					params.company_id = sessionStorage.getItem("COMPANY")
					Api('need/save',params).then((res) => {
						if(res.code==200){
							this.needRefresh = true
							this.$message({message: '保存成功!',type: 'success',duration:1000,onClose:function(){window.close();}});
						}else{
							this.$message.error(res.msg)
						}
					})
				} else {
					this.$message({message: '必填项不能为空',type: 'error'})
				}
			})
		},
		view(){
			let routeData = this.$router.resolve({ path: '../needDetail',query:{id:this.id}});
			window.open(routeData.href, '_blank');
		},
		remove(){
			this.$confirm('数据删除后不可恢复, 是否继续删除?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'
			}).then(() => {
				Api('need/remove',{id:this.$route.query.id}).then((res) => {
					if(res.code==200){
						this.needRefresh = true
						window.close()
					}else{
						this.$message.error(res.msg)
					}
				})
			}).catch((err)=>{});
		},
	}
}
</script>
<style scoped>
.demand-issued-info {
  padding: 30px;
  border-radius: 10px;
  background-color: #fff;
  margin-top: 90px;
  overflow: hidden;
}
.wrapper-title {
  margin-bottom: 20px;
  padding: 0 15px;
  font-size: 20px;
  font-family: PingFang;
  font-weight: bold;
  color: #222222;
  background-image: linear-gradient(to right, #4a73ff 4px, transparent 4px);
}
.save {
  width: 120px;
  height: 40px;
  background: #4a73ff;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
  margin-top: 20px;
  float: right;
  text-align: center;
  cursor: pointer;
  margin-left: 20px;
}
:deep(.el-form-item__label) {
  font-size: 14px;
  font-family: PingFang;
  font-weight: bold;
  color: #222222;
}
:deep(.el-input__inner) {
  height: 34px;
  background: #f9f9f9;
  border: 1px solid #efefef;
  border-radius: 2px;
}
:deep(.required .el-form-item__label::after) {
  content: '*';
  color: #db221a;
}
</style>
